import { render, staticRenderFns } from "./aWorkDetailTask.vue?vue&type=template&id=185baf03&scoped=true"
import script from "./aWorkDetailTask.vue?vue&type=script&lang=js"
export * from "./aWorkDetailTask.vue?vue&type=script&lang=js"
import style0 from "./aWorkDetailTask.vue?vue&type=style&index=0&id=185baf03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185baf03",
  null
  
)

export default component.exports